export default "__VITE_ASSET__BAW1Gxo3__"